module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am459-9540bc8b17f31e62d5fc076c185b9e20.jpg";